$(function() {
	var image 			= document.getElementById('crop_image')	;
	var	rotateAngle		=	0									;	

	const cropper = new Cropper(image, {
			  crop: function(event) {
			    $('#crop_x').val(event.detail.x);
			    $('#crop_y').val(event.detail.y);
			    $('#crop_w').val(event.detail.width);
			    $('#crop_h').val(event.detail.height);
			  }
			  
	});
	
	$("#crop_rotate_left").click(function(){
	//	cropper("rotate",-90)				;
		rotateAngle -= 90					;
		cropper.rotate(-90)					;
		$('#rotation').val(rotateAngle)		;
	});
	
	$("#crop_rotate_right").click(function(){
		rotateAngle += 90					;
		cropper.rotate(90)					;
		$('#rotation').val(rotateAngle)		;
	});
	
	$("#crop_reset").click(function(){
		cropper.reset()		;
	});
	
  

  	const canvas 	= cropper.getCroppedCanvas();

});